// Gemeinsame Texte: Navigationsleiste, Fußzeile, Sprachauswahl.
// Übersetzung von fr/common.js — exakt dieselben Schlüssel.
// Die packs.*-Schlüssel gehören AUSSCHLIESSLICH in dieses Fragment (tp/tpList
// lesen sie, mit Rückfall auf den Wert aus der Datenbank).
export default {
  'nav.home': 'Startseite',
  'nav.shop': 'Shop',
  'nav.rules': 'Spielregeln',
  'nav.about': 'Über uns',
  'nav.contact': 'Kontakt',
  'nav.cart': 'Mein Warenkorb',
  'nav.admin': 'Verwaltung',
  'nav.adminShort': 'Admin',
  'nav.adminTitle': 'Admin-Zugang',
  'nav.order': 'Bestellen',
  'nav.cartEmpty': 'Ihr Warenkorb ist leer',
  'nav.checkout': 'Zur Kasse',
  'nav.login': 'Anmelden',
  'nav.loginShort': 'Login',
  'nav.logout': 'Abmelden',
  'nav.orders': 'Bestellungen',
  'nav.myOrders': 'Meine Bestellungen',
  'nav.profile': 'Profil',
  'nav.myProfile': 'Mein Profil',
  'nav.language': 'Sprache',

  'footer.tagline':
    'Schaffen wir gemeinsam magische Familienmomente! Unsere Puzzles verwandeln das Gender Reveal Ihres Babys in ein unvergessliches Abenteuer.',
  'footer.badge.interactive': '🎲 Interaktiv',
  'footer.badge.festive': '🎊 Festlich',
  'footer.badge.family': '💝 Familie',
  'footer.nav': 'Navigation',
  'footer.legal': 'Rechtliches',
  'footer.privacy': 'Datenschutz',
  'footer.terms': 'Allgemeine Geschäftsbedingungen',
  'footer.paymentSecurity': 'Sichere Zahlung',
  'footer.legalNotice': 'Impressum',
  // Newsletter-Block: die französische Vorlage duzt hier (wie im Warenkorb),
  // während der Rest der Seite siezt — dieser Wechsel wird beibehalten.
  'footer.connected': 'Bleib in Kontakt',
  'footer.newsletter': 'Erhalte die neuesten Infos:',
  'footer.newsletterPlaceholder': 'deine@email.com',
  'footer.madeWith': 'Gemacht mit',
  'footer.madeFor': 'für magische Familien.',

  // Produkttexte (kommen normalerweise aus der Datenbank, hier über tp/tpList
  // übersetzt).
  'packs.flash.name': 'Pack Essentiel',
  'packs.flash.description': 'Nur die Spielbox — den Rest bereiten Sie selbst vor.',
  'packs.flash.longDescription':
    'Sie erhalten die Joyful-Reveal-Box, und sonst nichts: elf Puzzleteile, die Frage für Frage gewonnen werden, und das zwölfte zum Freirubbeln — das Teil, das alles verrät. Die Spielregeln sind auf der Rückseite der Box zusammengefasst und stehen auch online zur Verfügung. Die Fragen schreiben Sie selbst, und Sie sorgen selbst für etwas, woran sich die beiden Teams unterscheiden lassen. Wenn Sie lieber möchten, dass schon alles bereitliegt, schauen Sie sich das Pack Premium an.',
  'packs.flash.features':
    'Die Spielbox mit ihren 12 Teilen|11 Teile zu gewinnen + 1 Rubbelteil|Spielregeln auf der Rückseite der Box zusammengefasst|Online-Version der Regeln über den QR-Code',

  'packs.premium.name': 'Pack Premium',
  'packs.premium.description': 'Das komplette Spiel: Alles liegt bereit, Sie müssen nur noch auspacken.',
  'packs.premium.longDescription':
    'Alles, was in der Box steckt, plus die drei Extras, die den Abend ausmachen: zwei Stoffbeutel, um die Teams voneinander zu unterscheiden, der auf 400-g-Karton gedruckte Fragebogen mit den elf bereits ausformulierten Fragen und einer Blankovorlage für Ihre eigenen, und ein Erinnerungsumschlag, den Sie nach dem Fest hinter einen Bilderrahmen schieben.',
  'packs.premium.features':
    'Die Spielbox mit ihren 12 Teilen|2 Stoffbeutel für die beiden Teams|Der auf 400-g-Karton gedruckte Fragebogen|Eine Blankovorlage für Ihre eigenen Fragen|Der Erinnerungsumschlag zum Aufbewahren nach dem Fest',
  "footer.maFacture": "Meine Rechnung finden",
};
